export default __webpack_public_path__ + "static/210602_夏日活動強更預告_sc-3dcd8f35f442149bd11c993cd34cb499.webp";